module.exports = __webpack_public_path__ + "img/cards-logo.e47cbf3.png";